import React, {FC} from 'react';
import styled from 'styled-components';

import {useAppSelector} from '../../../helpers/reduxHelpers';
import {
  getIsInTrialOrManagedTrial,
  getIsNotificationCenterEnabled,
} from '../../../store/data/company/companySelectors';
import {AppPanelId} from '../../../store/panels/panelStateBase';
import {Help} from './help/help';
import {Incidents} from './incidents/incidents';
import {NotificationsCenter} from './notificationsCenter/notificationsCenter';
import {SettingsAppButton} from './settingsAppButton';
import {UserProfile} from './userProfile/userProfile';

/*
 * Props.
 */

interface SettingsSectionProps {
  panelId: AppPanelId;
  isSettingsAppSelected: boolean;
}

/*
 * Styles.
 */

const StyledSettingsSectionWrapper = styled.div`
  -webkit-app-region: drag;
  margin-right: -3px;

  grid-area: settings;
  justify-content: flex-end;

  display: flex;
`;

/*
 * Component.
 */

export const SettingsSection: FC<SettingsSectionProps> = ({panelId, isSettingsAppSelected}) => {
  const shouldHideIncidents = useAppSelector(getIsInTrialOrManagedTrial);
  const isNotificationCenterEnabled = useAppSelector(getIsNotificationCenterEnabled);

  return (
    <StyledSettingsSectionWrapper>
      {!shouldHideIncidents && <Incidents />}
      <Help />
      <SettingsAppButton panelId={panelId} isSelected={isSettingsAppSelected} />
      {isNotificationCenterEnabled && <NotificationsCenter />}
      <UserProfile />
    </StyledSettingsSectionWrapper>
  );
};
